import { Injectable } from "@angular/core";
import { EMPTY, from, mergeMap, of } from "rxjs";
import { STANDALONE } from "../../_offline/electron.constants";
import { AppInfoSchema } from "../../_offline/models/app-info.schema";
import { AppInfoDbService } from "../database/app-info-db.service";
import { LoginUserOnlineService } from "../http-api/login-user-online.service";
import { NetworkStatusService } from "../network-status.service";
import { PushOfflineDataSyncService } from "./push-offline-data-sync.service";
import { OnPremiseFirstSyncService } from "./sync-on-premise-data/on-premise-first-sync.service";
import { OnPremiseSyncProgressDialogComponent } from "../../on-premise-sync-progress-dialog/on-premise-sync-progress-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { catchError } from "rxjs/operators";
import { CommonSnackBarService } from "../common-snack-bar.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class SendOfflineDataService {

  constructor(
    private networkStatusService: NetworkStatusService,
    private appInfoService: AppInfoDbService,
    private firstSyncService: OnPremiseFirstSyncService,
    private pushOfflineData: PushOfflineDataSyncService,
    private loginUserOfflineService: LoginUserOnlineService,
    private dialog: MatDialog,
    private snackbar: CommonSnackBarService,
    private translateService: TranslateService
  ) { }

  public syncData() {
    if (!this.networkStatusService.isDesktop || !this.networkStatusService.isOnline) {
      return EMPTY;
    }

    return this.appInfoService.get()
      .pipe(
        mergeMap(appInfo =>
          this.sendOfflineData(appInfo).pipe(
            catchError(err => {
              this.snackbar.open(this.translateService.instant('inspectionlist.syncError'));
              this.dialog.closeAll();
              return of();
            })
          )
        ),
        mergeMap(() => this.appInfoService.putSwitchOnlineBy(null)));
  }

  private openSyncProgressDialog() {
    this.dialog.open(OnPremiseSyncProgressDialogComponent);
  }

  private sendOfflineData(appInfo: AppInfoSchema) {
    if (appInfo.switchOnlineBy == STANDALONE.USER_ID) {
      this.openSyncProgressDialog();
      return this.firstSyncService.syncOfflineData();
    }
    return from(this.pushOfflineData.syncOfflineData());
  }
}
